import React from 'react'

const Section5 = () => {
    return (
        <section id="section5">
            <div className="target t1"></div>
            <div className="target t2"></div>
            <div className="target t3"></div>
            <div className="target t4"></div>
            <div className="text">
                <h3 className="title">Contact Me</h3>
                <a href="mailto:adorableness1215@naver.com" rel="noopener noreferrer">adorableness1215@naver.com</a>
            </div>
            <div className="arrow"></div>
        </section>
    )
}

export default Section5